import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
const CopyBox = (props) => {
  const { isOpen, text, functions, close, copyAnzahl, placeholderName, _type } =
    props;
  const [inputFieldValue, setInputFieldValue] = useState("");
  var displaystyle = isOpen ? { display: "block" } : { display: "none" };
  var _class = isOpen ? "show" : "";

  useEffect(() => {
    setInputFieldValue(copyAnzahl || "");
  }, [copyAnzahl]);

  function handleInput(inputValue) {
    setInputFieldValue(inputValue);
  }

  return isOpen ? (
    <>
      <div
        className={"modal fade " + _class}
        id="MsgModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="MsgModalCenterTitle"
        aria-hidden="true"
        style={displaystyle}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="MsgModalLongTitle">
                {text.title}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setInputFieldValue("");
                  close();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-auto ">
              <h2>{text.msg}</h2>

              <div className="form-group">
                <input
                  type={_type}
                  className="form-control"
                  name="anzahl"
                  placeholder={placeholderName}
                  value={inputFieldValue}
                  min={_type === "number" ? 1 : ""}
                  onKeyPress={(e) => {
                    // Allow only numeric keys (0-9)
                    if (_type === "number") {
                      let isValidInput;
                      if (inputFieldValue === "") {
                        isValidInput = /^[1-9\b]+$/.test(e.key);
                      } else {
                        isValidInput = /^[0-9\b]+$/.test(e.key);
                      }
                      if (!isValidInput) {
                        e.preventDefault();
                      }
                    }
                  }}
                  onChange={(event) => {
                    handleInput(event.target.value);
                    // setCopyAnzahl(event.target.value);
                  }}
                />
              </div>
            </div>
            <div className="modal-footer py-3">
              <div className="form-group  my-0 d-flex">
                {isOpen &&
                  functions &&
                  functions.map((value, index) => {
                    return (
                      <button
                        key={index}
                        type="button"
                        className="btn btn-primary ml-2"
                        disabled={inputFieldValue === "" && value.type === "ok"}
                        onClick={(e) => {
                          e.preventDefault();
                          value.func(inputFieldValue, text.anlageID);
                          setInputFieldValue("");
                        }}
                      >
                        {value.title}
                      </button>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
};
export default CopyBox;
